import { Badge } from "@/components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import type { LowStockItemRow } from "@/modules/inventory/domain/types";
import {
  stockPolicyItemTypeLabel,
} from "@/modules/inventory/presentation/ui/stock-policy/stockPolicyLaoLabels";
import {
  TRANSFER_CARD_CONTENT_TABLE,
  TRANSFER_LIST_SHELL,
} from "@/modules/inventory/presentation/ui/transfers/transferCardLayout";
import { formatQtyDisplay } from "@/shared/lib/format-number";
import { Link } from "@tanstack/react-router";

type LowStockReportsTableProps = {
  items: LowStockItemRow[];
  isLoading?: boolean;
};

export function LowStockReportsTable({
  items,
  isLoading,
}: LowStockReportsTableProps) {
  return (
    <div className={TRANSFER_LIST_SHELL}>
      <div className={TRANSFER_CARD_CONTENT_TABLE}>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>ລາຍການ</TableHead>
              <TableHead>ປະເພດ</TableHead>
              <TableHead className="text-right">ຄົງເຫຼືອ</TableHead>
              <TableHead className="text-right">ຂັ້ນຕ່ຳ</TableHead>
              <TableHead className="text-right">ເປົ້າ</TableHead>
              <TableHead className="text-right">% ເທົ່າ min</TableHead>
              <TableHead>ເກັນໄຂ</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={7} className="py-8 text-center text-muted-foreground">
                  ກຳລັງໂຫຼດ…
                </TableCell>
              </TableRow>
            ) : items.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} className="py-8 text-center text-muted-foreground">
                  ບໍ່ມີລາຍການຕ່ຳກວ່າເກັນໄຂ — ຫຼື ຍັງບໍ່ຕັ້ງ policy
                </TableCell>
              </TableRow>
            ) : (
              items.map((row) => {
                const pct =
                  row.minQty > 0
                    ? Math.round((row.onHand / row.minQty) * 100)
                    : 0;
                return (
                  <TableRow key={`${row.itemType}:${row.itemId}`}>
                    <TableCell>
                      <span className="font-medium">{row.itemName}</span>
                      <span className="ml-1 text-muted-foreground text-xs">
                        ({row.unit})
                      </span>
                    </TableCell>
                    <TableCell className="text-sm">
                      {stockPolicyItemTypeLabel(row.itemType)}
                    </TableCell>
                    <TableCell className="text-right tabular-nums">
                      {formatQtyDisplay(row.onHand)}
                    </TableCell>
                    <TableCell className="text-right tabular-nums">
                      {formatQtyDisplay(row.minQty)}
                    </TableCell>
                    <TableCell className="text-right tabular-nums">
                      {formatQtyDisplay(row.effectiveTargetQty)}
                    </TableCell>
                    <TableCell className="text-right tabular-nums">
                      {pct}%
                    </TableCell>
                    <TableCell>
                      <Badge variant="outline" className="mr-2">
                        {row.policySource === "branch" ? "ສາຂາ" : "Global"}
                      </Badge>
                      <Link
                        to="/app/inventory/stock-policies"
                        search={{
                          policyBranch:
                            row.policySource === "branch"
                              ? row.branchId
                              : "__global__",
                          onHandBranchId: row.branchId,
                        }}
                        className="text-primary text-xs hover:underline"
                      >
                        ແກ້ເກັນໄຂ
                      </Link>
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
